import { render, staticRenderFns } from "./RegisterWizardStepOne.vue?vue&type=template&id=156ca216&scoped=true"
import script from "./RegisterWizardStepOne.vue?vue&type=script&lang=js"
export * from "./RegisterWizardStepOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156ca216",
  null
  
)

export default component.exports